import DownMouse from "../components/downMouse";
import services from "../static files/images/Glass-on-suckerbank-curatin-wall.jpg";
import check from "../static files/images/check.png";
import azglass from "../static files/images/office images/photo_9_2025-10-15_21-48-14.jpg";
import azglassFront from "../static files/images/office images/photo_6_2025-10-15_21-48-14.jpg";
import whyimg2 from "../static files/images/office images/photo_11_2025-10-15_21-48-14.jpg";
import whyimg3 from "../static files/images/office images/photo_16_2025-10-15_21-48-14.jpg";
import whyimg4 from "../static files/images/office images/photo_22_2025-10-15_21-48-14.jpg";
import table from "../static files/images/office images/photo_19_2025-10-15_21-48-14.jpg";
import arrow from "../static files/images/right-arrow.png";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getOfficeImages } from "../slices/officeReducer";
import Loading from "../components/Loading";
import { NavLink } from "react-router-dom";
const About = () => {
  const cardsRef = useRef(null);
  const dispatch = useDispatch();
  const { images, status } = useSelector((state) => state.office);

  useEffect(() => {
    dispatch(getOfficeImages());
    console.log(images);
  }, [dispatch]);

  const scrollAmount = 300; // hər klikdə 300px sola/sağa gedəcək, lazım gələrsə dəyiş

  const scrollRight = () => {
    if (cardsRef.current) {
      cardsRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };

  const scrollLeft = () => {
    if (cardsRef.current) {
      cardsRef.current.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    }
  };

  if (status === "loading") {
    return <Loading />;
  }

  return (
    <main>
      <section className="about-hero">
        <h1>Haqqımızda</h1>
        <h2>
          AzGlass Design müasir memarlıq dizaynını qabaqcıl günəş və izolyasiya
          texnologiyaları ilə birləşdirərək enerji səmərəli, funksional və
          estetik cəhətdən cəlbedici bina həlləri təqdim edən aparıcı şirkətdir.
          Peşəkar komandamız innovativ mühəndislik yanaşmaları və davamlı
          praktikalardan istifadə edərək, icmaların və bizneslərin daha yaşıl və
          səmərəli gələcəyə doğru addım atmasına dəstək olur.
        </h2>
        <div className="down-mouse">
          <DownMouse />
        </div>
      </section>

      <section className="azglass-section">
        <div className="header">
          <div className="line-horizontal"></div>
          <div className="header-text">
            <div className="circle"></div>
            <h3>AzGlass Design</h3>
            <div className="line-vertical"></div>
          </div>
        </div>

        <div className="section-body">
          <article className="text-box">
            <h2>AzGlass: Bacarığımızın sərhədi yoxdur</h2>
            <h3>
              AzGlass Design Group olaraq biz hər cür şüşə və pəncərə
              sistemlərinin layihələndirilməsi, istehsalı və quraşdırılmasında
              ixtisaslaşmışıq. Enerji səmərəli, estetik və davamlı həllər təqdim
              edərək, müştərilərimizin tələblərinə uyğun ən doğru nəticələri
              ortaya qoyuruq. Məhdudiyyət tanımırıq – imkanlarımız layihənizin
              ehtiyacları qədər genişdir.
            </h3>
            <NavLink to={"/contact"}>Əlaqə</NavLink>
            <ul className="services-cards">
              <li>
                <article className="card">
                  <div className="image-box">
                    <img src={check} alt="Metal Konstruksiya" />
                  </div>
                  <h4>Vizyon & Peşəkarlıq</h4>
                </article>
              </li>
              <li>
                <article className="card">
                  <div className="image-box">
                    <img src={check} alt="Metal Konstruksiya" />
                  </div>
                  <h4>Yaradıcı Həllər</h4>
                </article>
              </li>
              <li>
                <article className="card">
                  <div className="image-box">
                    <img src={check} alt="Metal Konstruksiya" />
                  </div>
                  <h4>Mütəxəssis Dəstək</h4>
                </article>
              </li>
            </ul>
          </article>

          <img src={azglass} alt="Azglass" />
        </div>
      </section>

      <section className="why-section">
        <div className="header">
          <div className="line-horizontal"></div>
          <div className="header-text">
            <div className="circle"></div>
            <h3>Niyə AzGlass ?</h3>
            <div className="line-vertical"></div>
          </div>
        </div>

        <div className="section-body">
          <h2>Sizin üçün niyə doğru seçim bizik ?</h2>
          <h3>
            AzGlass olaraq biz müasir texnologiya, yüksək keyfiyyətli
            materiallar və peşəkar komandamızla uzunömürlü, estetik və enerji
            səmərəli həllər təqdim edirik. Hər bir layihəyə fərdi yanaşaraq,
            müştərilərimizin xüsusi tələblərini nəzərə alır, onların
            ehtiyaclarına tam uyğun, funksional və gözoxşayan nəticələr əldə
            etməyi əsas məqsədimiz kimi görürük. Bizim üçün hər detal önəmlidir
            – layihənin planlaşdırılmasından başlayaraq istehsal və montaj
            mərhələsinə qədər hər addımda maksimum keyfiyyət və dəqiqliyi təmin
            edirik. Bu yanaşma sayəsində həm şəxsi, həm də kommersiya
            obyektlərində ən yüksək standartlara cavab verən həllər təqdim
            edirik, müştərilərimizin məmnuniyyətini və uzunmüddətli faydanı
            təmin edirik.
          </h3>
          <div className="list-box">
            <div className="arrows">
              <img
                className="left-arrow"
                src={arrow}
                alt="left-arrow"
                onClick={scrollLeft}
                style={{ cursor: "pointer" }}
              />
              <img
                className="right-arrow"
                src={arrow}
                alt="right-arrow"
                onClick={scrollRight}
                style={{ cursor: "pointer" }}
              />
            </div>
            <ul className="cards" ref={cardsRef}>
              {images?.map((i, index) => (
                <li key={index}>
                  <img src={i.image} alt="meheccer" />
                </li>
              ))}
            </ul>
          </div>
          <div className="line-div">
            <h4>
              AzGlass Design olaraq biz yalnız gələcəyi təsəvvür etmirik onu
              inşa edirik. Elə bir gələcək ki, Günəşin toxunduğu hər bir səth
              enerji mənbəyinə çevrilir.
            </h4>
            <NavLink to={"/contact"}>Layihələrimizi izləyin</NavLink>
          </div>
        </div>
      </section>

      <section className="services-section">
        <div className="header">
          <div className="line-horizontal"></div>
          <div className="header-text">
            <img src={table} alt="Azglass" />
            <div className="circle"></div>
            <h3>Xidmətlər</h3>
            <div className="line-vertical"></div>
          </div>
        </div>

        <div className="section-body">
          <h2>Sizin vizyonunuz, bizim peşəkarlığımız</h2>
          <h3>
            Müştərilərimiz sadələşdirilmiş yalnız təchizat variantını, yoxsa tam
            həll imkanlarımızı üstün tutmasından asılı olmayaraq, AzGlass Design
            hər zaman problemsiz və səmərəli bir təcrübə təmin edir. Biz dizayn
            və dəstəkdən başlayaraq quraşdırma və sənayedə lider zəmanət
            xidmətinə qədər bütün mərhələlərdə maksimum rahatlıq və keyfiyyət
            təqdim edirik. Hər şeyi sadə və əlçatan edirik.
          </h3>
          <div className="contact-button">
            <div className="circle"></div>
            <p>Daha ətraflı məlumat üçün bizimlə əlaqə saxlayın.</p>
            <a href="#">Əlaqə</a>
          </div>
        </div>

        <ul className="services-cards">
          <li>
            <article className="card">
              <div className="image-box">
                <img src={check} alt="Metal Konstruksiya" />
              </div>
              <h4>İnnovasiya</h4>
            </article>
          </li>
          <li>
            <article className="card">
              <div className="image-box">
                <img src={check} alt="Metal Konstruksiya" />
              </div>
              <h4>Layihəniz, Bizim Ekspertliyimiz</h4>
            </article>
          </li>
          <li>
            <article className="card">
              <div className="image-box">
                <img src={check} alt="Metal Konstruksiya" />
              </div>
              <h4>Mükəmməl Nəticə</h4>
            </article>
          </li>
        </ul>
      </section>

      <section className="location-section">
        <h2>Ofisimizin xəritə üzərində məkanı</h2>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1659.649211303713!2d49.85986073375978!3d40.39249117023704!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40307d152bd7d73b%3A0x92a47a0852f48752!2zOTUgUWFyYWJhxJ8ga8O8w6fJmXNpLCBCYWvEsQ!5e0!3m2!1saz!2saz!4v1758971556771!5m2!1saz!2saz"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </section>
    </main>
  );
};

export default About;
